
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watch/[id]",
      function () {
        return require("private-next-pages/watch/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watch/[id]"])
      });
    }
  